module.exports = __webpack_public_path__ + "static/media/gmail_icon.f96c85c3.png";